import { useMemo } from "react";
import {
  calculateOrderTotalItemDiscount,
  formatCurrency,
} from "../../../../../helpers";
import styles from "./styles.module.scss";

export const PriceSummary = ({ orderDetails, summaryType = "SOLD" }) => {
  const store_currency = orderDetails?.store?.currency_code;
  const itemDiscountAmount = useMemo(
    () => calculateOrderTotalItemDiscount(orderDetails),
    [orderDetails],
  );

  return (
    <div className={styles.priceSummary}>
      <p className="dark--text text-center">Price Summary</p>
      {summaryType === "SOLD" ? (
        <>
          <div>
            <p>Subtotal</p>
            <p className="dark--text font-weight-semibold">
              {formatCurrency({
                value: orderDetails?.total_item_amount,
                currencyCode: store_currency,
              })}
            </p>
          </div>
          {orderDetails?.giftcard_debit_amount ? (
            <div>
              <p>Gift Card</p>
              <p className="dark--text font-weight-semibold">
                {formatCurrency({
                  value: orderDetails?.giftcard_debit_amount || 0,
                  currencyCode: store_currency,
                })}
              </p>
            </div>
          ) : null}
          {orderDetails?.loyalty_debit_amount ? (
            <div>
              <p>Loyalty Amount</p>
              <p className="dark--text font-weight-semibold">
                {formatCurrency({
                  value: orderDetails?.loyalty_debit_amount || 0,
                  currencyCode: store_currency,
                })}
              </p>
            </div>
          ) : null}
          {itemDiscountAmount > 0 && (
            <div>
              <p>Item Discount</p>
              <p className="dark--text font-weight-semibold text-danger">
                -
                {formatCurrency({
                  value: itemDiscountAmount,
                  currencyCode: store_currency,
                })}
              </p>
            </div>
          )}
          <div>
            <p>{itemDiscountAmount > 0 ? "Order Discount" : "Discount"}</p>
            <p className="dark--text font-weight-semibold">
              {formatCurrency({
                value: orderDetails?.discount_amount || 0,
                currencyCode: store_currency,
              })}
            </p>
          </div>
          <div>
            <p>Delivery Fee</p>
            <p className="dark--text font-weight-semibold">
              {formatCurrency({
                value: orderDetails?.delivery_fee_amount || 0,
                currencyCode: store_currency,
              })}
            </p>
          </div>
          <div>
            <p>VAT</p>
            <p className="dark--text font-weight-semibold">
              {formatCurrency({
                value: orderDetails?.vat || 0,
                currencyCode: store_currency,
              })}
            </p>
          </div>
          <div>
            <p>
              Service Charge (
              {isNaN(Number(orderDetails?.service_charge_percentage))
                ? 0
                : Number(orderDetails?.service_charge_percentage)}
              %)
            </p>
            <p className="dark--text font-weight-semibold">
              {formatCurrency({
                value: orderDetails?.service_charge || 0,
                currencyCode: store_currency,
              })}
            </p>
          </div>
          <div>
            <p className="dark--text font-weight-semibold">Total</p>
            <h5 className="success--text">
              {formatCurrency({
                value: orderDetails?.total_amount,
                currencyCode: store_currency,
              })}
            </h5>
          </div>
        </>
      ) : (
        <>
          <div>
            <p>Subtotal</p>
            <p className="dark--text font-weight-semibold">
              {formatCurrency({
                value: orderDetails?.returns_subtotal,
                currencyCode: store_currency,
              })}
            </p>
          </div>
          <div>
            <p>VAT</p>
            <p className="dark--text font-weight-semibold">
              {formatCurrency({
                value: orderDetails?.total_return_tax,
                currencyCode: store_currency,
              })}
            </p>
          </div>
          <div>
            <p className="dark--text font-weight-semibold">Total</p>
            <h5 className="success--text">
              {formatCurrency({
                value: orderDetails?.total_returned_amount,
                currencyCode: store_currency,
              })}
            </h5>
          </div>
        </>
      )}
    </div>
  );
};
